import DocumentComponent from "../Components/Document/DocumentComponent"

function DocumentPage() {
    return (
        <DocumentComponent/>
    )
}

export default DocumentPage